import { Component, OnInit, ViewChild } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { Subscription } from 'rxjs';
import { ChartOptions } from 'libs/portal/src/models/ChartOptions';
import { Filter } from 'libs/portal/src/models/Filter';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { Endpoints } from '@huge-monorepo/portal/config';

@Component({
  selector: 'app-relay-line-graph',
  templateUrl: './relay-line-graph.component.html',
  styleUrls: ['./relay-line-graph.component.scss'],
})
export class RelayLineGraphComponent implements OnInit {
  @ViewChild('chart', { static: false }) chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  graphFilterData: Object = {
    StartDate: this.tools.FormatStartDate(new Date(new Date().getDate() - 1).toISOString()),
    EndDate: this.tools.FormatEndDate(new Date().toISOString()),
    TimePeriod: '4',
  };
  TimeFilters: Filter[];
  selectedInterval: Filter;
  graphLoaded = false;
  loading = true;

  sidenavObservable: Subscription;

  constructor(private genericService: GenericService, private tools: ToolsService, private endpoints: Endpoints, private navigationService: NavigationService) {}

  ngOnInit() {
    this.chartOptions = {
      series: [],
      chart: {
        type: 'line',
        height: 350,
        dropShadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2,
        },
        toolbar: {
          show: true,
        },
      },
      fill: {
        colors: ['#77B6EA'],
        type: 'solid',
        opacity: 0.5,
      },
      colors: ['#FFBE0B', '#FB5607', '#FF006E', '#8338EC', '#3A86FF', '#03045E', '#023E8A', '#FF9E00', '#fc2f00', '#00ffe7'],
      stroke: {
        curve: 'smooth',
      },
      dataLabels: {
        enabled: true,
      },
      title: {
        text: 'Average Tx/Rx',
        align: 'center',
      },
      markers: {
        size: 1,
        hover: {
          sizeOffset: 4,
        },
      },
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
        title: {
          text: 'Time',
        },
      },
      yaxis: {
        title: {
          text: 'Data (in bytes)',
        },
        // min: 0,
        // max: 105
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        floating: true,
        offsetY: -25,
        offsetX: -5,
      },
    };

    this.tools.GetTimeFilters().subscribe((filters) => {
      console.log({ filters });
      this.TimeFilters = filters;
      this.selectedInterval = this.TimeFilters[3];
      setTimeout(() => {
        this.getGraphData();
      }, 500);
    });

    this.sidenavObservable = this.navigationService.GetSideNav(() => {
      if (this.graphLoaded != false) {
        const temp = this.graphLoaded;
        this.graphLoaded = false;
        setTimeout(() => {
          this.graphLoaded = temp;
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sidenavObservable != null) {
      this.sidenavObservable.unsubscribe();
    }
  }

  buildGraphQueryObject() {
    const timePeriod = parseInt(this.graphFilterData['TimePeriod']);
    return {
      StartDate: '2022-05-01T00:00:00Z',
      EndDate: '2022-05-15T23:59:59Z',
      TimePeriod: timePeriod,
      GroupBy: null,
      Search: null,
      Paginate: true,
      Count: false,
    };
  }

  updateSelectedTimeFilter(eve) {
    console.log('TimeFilter changed: ', eve);
    this.selectedInterval = eve;
    this.refreshGraph();
  }

  updateStart(newDate: string) {
    console.log(newDate);
    this.graphFilterData['StartDate'] = newDate;
  }

  updateEnd(newDate: string) {
    console.log(newDate);
    const d = new Date(newDate);
    const date = new Date(newDate.substr(0, 10));
    date.setHours(d.getUTCHours());
    date.setMinutes(d.getUTCMinutes());
    date.setSeconds(d.getUTCSeconds());
    const today = new Date();
    if (today.getUTCFullYear() == date.getUTCFullYear() && today.getUTCMonth() == date.getUTCMonth() && today.getUTCDate() == date.getUTCDate()) {
      date.setHours(today.getHours() + 2);
      date.setMinutes(today.getUTCMinutes() - 5);
      date.setSeconds(0);
      date.setMilliseconds(0);
      newDate = date.toISOString();
      console.log('Changed new date format to: ' + newDate);
    }

    this.graphFilterData['EndDate'] = newDate;
  }

  getGraphData() {
    // this.loading = true;
    // this.graphLoaded = false;
    const obj = this.buildGraphQueryObject();
    console.log(obj);
    this.genericService
      .POST(
        this.endpoints.GET_RELAY_SERVER_TRANSACTIONS({
          count: 100,
          offset: 0,
          search: '',
          orderBy: 'Timestamp',
          desc: false,
        }),
        obj,
      )
      .subscribe(
        (results) => {
          console.log(results);
          if (results['body'] != null) {
            const labels = [];
            // let data = [];
            let currTimestamp = null;
            const resultMap = {};
            results['body'].forEach((element) => {
              if (resultMap[element.Timestamp] == null) {
                resultMap[element.Timestamp] = [element.Tx, element.Rx, 1];
              } else {
                resultMap[element.Timestamp][0] = Math.round((resultMap[element.Timestamp][0] + element.Tx) / (resultMap[element.Timestamp][2] + 1));
                resultMap[element.Timestamp][1] = Math.round((resultMap[element.Timestamp][1] + element.Rx) / (resultMap[element.Timestamp][2] + 1));
                resultMap[element.Timestamp][2] = resultMap[element.Timestamp][2] + 1;
              }

              if (currTimestamp == null || element.Timestamp != currTimestamp) {
                labels.push(element.Timestamp);
                currTimestamp = element.Timestamp;
              }
            });

            this.chartOptions.series = [
              {
                name: 'Tx',
                data: [],
              },
              {
                name: 'Rx',
                data: [],
              },
            ];
            Object.entries(resultMap).forEach(([, value]) => {
              // console.log(key,value)
              this.chartOptions.series[0].data.push(value[0]);
              this.chartOptions.series[1].data.push(value[1]);
            });

            this.chartOptions.xaxis.categories = labels;
          }

          this.loading = false;
          this.graphLoaded = true;
        },
        (err) => {
          console.log(err);
        },
      );
  }

  timeFrameSelected(timeFrame) {
    console.log({ timeFrame });
    if (parseInt(this.graphFilterData['TimePeriod']) != 0) {
      this.refreshGraph();
    }
  }

  refreshGraph() {
    // console.log("refresh graph");
    this.loading = true;
    this.graphLoaded = false;
    this.chartOptions.series = [];
    // this.selectedInterval = this.TimeFilters[3];
    setTimeout(() => {
      this.getGraphData();
    }, 500);
  }
}
